import { Component, OnInit } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';
import { Offer, OfferCodeDisplayType, OfferCodeType, OfferLocationType } from 'src/models/Offer';
import { ApiService } from '../api.service';
import {Location} from '@angular/common';
import { RetailerLocation } from 'src/models/RetailerLocation';
import { RetailerWithLocations } from 'src/models/Retailer';
import { VisibilityStatus } from 'src/models/VisibilityStatus';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss']
})
export class OfferComponent implements OnInit {
  private sub: any;
  offer: Offer;
  constructor(private route: ActivatedRoute, private api: ApiService, private router: Router, private location: Location) {

  }
  hasTime: boolean;
  onPremChanged(e: MatSlideToggleChange) { 
    if (e.checked) {
      this.offer.locationType = OfferLocationType.OnPremise;
    } else {
      this.offer.locationType = OfferLocationType.Anywhere;
    }
    this.onPrem = this.offer.locationType == 1;
  }
  hasTimeChanged(e: MatSlideToggleChange) {
    this.hasTime = e.checked;

    if (!this.hasTime) {
      this.offer.availability.startTimeOfDay = null;
      this.offer.availability.endTimeOfDay = null;
    }
    else {
      this.offer.availability.startTimeOfDay = "12:00 am";
      this.offer.availability.endTimeOfDay = "11:59 pm";
    }
  }
  retailerId: string;
  retailer: RetailerWithLocations =<RetailerWithLocations> { locations:[]};

  async updateRetailer() {
    this.retailer = await this.api.getRetailer(this.retailerId);
  }
  imagePickerConf = {
    borderRaduis: "5%",
    language: "en",
    width: "150px",
    height: "150px"
  };

  offerImageType: string = null;
  offerImageBlob: string = null;
  onImageChange(event: string) {  
    if (event == null) {
      this.offerImageType = null;
      this.offerImageBlob = null;
      return;
    }
    console.log("image changed");
    console.log(event);
    let idx = event.indexOf(";");
    let type : any = event.substr(0, idx);
    type = type.split("data:")[1];
    let data = event.split(";base64,")[1];
    console.log("type is: " + type);
    console.log("data is: " + data);
    this.offerImageType = type;
    this.offerImageBlob = data;
  }
  async ngOnInit() {
    this.sub = this.route.params.subscribe(async params => {
      this.offerImageBlob = null;
      this.offerImageType = null;
      this.retailerId = params['retailerId'];
      await this.updateRetailer();
      if (params['offerId'] == "new") {
        console.log("")
        this.offer = {
          id: null,
          retailerId: null,
          locationIds: this.retailer.locations.map(x=> x.id),
          displayName: "",
          details: "",
          imageUrl: "",
          availability: {
          },
          locationType: OfferLocationType.Anywhere,
          codeDisplayType: OfferCodeDisplayType.None,
          codeType: OfferCodeType.Static,
          redeemCode: "",
          redeemInstructions: "",
          hasChanges: true,
          visibility: VisibilityStatus.Private
        };
        if (this.offer.availability.startTimeOfDay || this.offer.availability.endTimeOfDay) {
          this.hasTime = true;
        }
        this.onPrem = this.offer.locationType == 1;
      } else {
       this.loadOffer(params['retailerId'], params['offerId']);
      }
    });
  }

onPrem: boolean;
  private async loadOffer(location_id: string, offer_id: string) {
    this.offer = await this.api.getOfferForRetailer(location_id, offer_id);
    if (this.offer.availability.startTimeOfDay || this.offer.availability.endTimeOfDay) {
      this.hasTime = true;
    }
    this.onPrem = this.offer.locationType == 1;
    console.log("data: " + this.offer.codeDisplayType);
  }

  async saveOffer() {
    console.log("saving offer");
    let savedOffer : Offer;
    let wasNew = false;
    let copy = JSON.parse(JSON.stringify(this.offer));
    if (this.offerImageBlob && this.offerImageType) {
      copy.imageUrl_blob = this.offerImageBlob;
      copy.imageUrl_mime = this.offerImageType;
    }
    if (!this.offer.id) {
      savedOffer = await this.api.createRetailerOffer(this.retailerId, copy);
      wasNew = true;
    } else {
      savedOffer = await this.api.patchRetailerOffer(this.retailerId, copy);
    }
    console.log("navigating");
    this.offer = savedOffer;
    this.location.back();
    //this.router.navigate("..");//['/retailers', this.retailerId, 'offers', savedOffer.id], { replaceUrl: true });
    
  }

  async deleteOffer() {
    await this.api.deleteRetailerOffer(this.retailer.id, this.offer);
    this.location.back();
  }
}
